import { render, staticRenderFns } from "./rubric_grade_level_radio_group.vue?vue&type=template&id=098a9185&"
import script from "./rubric_grade_level_radio_group.vue?vue&type=script&lang=js&"
export * from "./rubric_grade_level_radio_group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports